import { Heading, SxProp } from '@primer/react';
import Text from '../text';
interface IHeadingProps extends SxProp {
    size?: "small" | "medium" | "large" | undefined,
    text: string
}
const MyHeading = (props: IHeadingProps) => {
    return (
        <Heading sx={{
            fontSize: "24px",
            ...props.sx
        }}
        >
            <Text text={props.text} />
        </Heading>
    );
};

export default MyHeading;